import axios from "axios";
import { setTaxiEndpoint } from "../GetReservation";
import { GetDirectionAndFareParams, GetDirectionAndFareSamplesParams } from "./models/getFareSamplesParams";

interface ApiConfig {
  baseURL: string;
  timeout: number;
}

const DEFAULT_API_CONFIG: ApiConfig = {
  baseURL: process.env['REACT_APP_API_ENDPOINT'] as string,
  timeout: 60000,
};

/**
 * 必要なパラメーターを満たしているか
 * @param params チェックパラメーター
 * @param isTemporaryReservation 仮予約画面か
 */
const checkParams = (params: GetDirectionAndFareParams | GetDirectionAndFareSamplesParams) => {
  // to空港の場合、出発地点・出発地点座標がないとエラーにする
  if(!(params.pointInfo?.latLng && params.pointInfo?.label && params.pointInfo?.latLngForPriceCalc && params.pointInfo?.labelForPriceCalc)) {
    throw new Error('地点情報の要素が足りていません')
  }
}

/** タクシー経路料金算出APIを呼び出す */
export async function getDirectionAndFareAPI(params: GetDirectionAndFareParams) {
  // 必要なパラメーターが足りているかチェック
  checkParams(params)
  const path = setTaxiEndpoint('get-fare-info');
  const config = {
    ...DEFAULT_API_CONFIG,
  };
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  /** axiosのインスタンス。 */
  const instance = axios.create(config);
  // 仮予約APIにPOSTメソッドでリクエストする。
  const response = await instance.post(path, params);
  // Response結果が正常ならデータを返す
  // 距離ラベルと料金ラベルが取れない時にもエラーを返す
  if(response.status === 200 && response.data && response.data.distanceLabel && response.data.durationLabel) {
    return response.data;
  }
  else {
    // エラーが発生した場合は、debugレベルでエラーログを出力するのみとする。
    // dev環境のみエラーログを出力
    if(process.env['REACT_APP_STAGE_ENV'] === 'dev') {
      console.error(response);
    }
    return null;
  }
}

/** 汎用タクシー経路料金算出APIを呼び出す */
export async function getDirectionAndFareSamplesAPI(params: GetDirectionAndFareSamplesParams) {
  // 必要なパラメーターが足りているかチェック
  checkParams(params)
  const path = setTaxiEndpoint('get-fare-samples-info');
  const config = {
    ...DEFAULT_API_CONFIG,
  };
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  /** axiosのインスタンス。 */
  const instance = axios.create(config);
  // 仮予約APIにPOSTメソッドでリクエストする。
  const response = await instance.post(path, params);
  // Response結果が正常ならデータを返す
  // 距離ラベルと料金ラベルが取れない時にもエラーを返す
  if(response.status === 200 && response.data) {
    return response.data;
  }
  else {
    // エラーが発生した場合は、debugレベルでエラーログを出力するのみとする。
    // dev環境のみエラーログを出力
    if(process.env['REACT_APP_STAGE_ENV'] === 'dev') {
      console.error(response);
    }
    return null;
  }
}